<section>
  <div class="container-style">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
        <p>Para realizar el proceso de importación del despiece de cotización, descargue la guía y siga los
          pasos:</p>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end ">
        <app-custom-button [label]="'Descargar Guía de Import.'" [severity]="'success'" [width]="'11rem'"
          (onClick)="downloadGuideImport()"></app-custom-button>
      </div>
      <hr class="my-2">
      <div class="col-lg-8 col-md-12 col-sm-12 col-12 d-flex">
        <input type="file" id="fileImport" (change)="getNameFile($event)"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden />
        <app-custom-button [label]="'Seleccionar archivo'" [severity]="'primary'" [width]="'9rem'"
          (onClick)="attachFileImport()"></app-custom-button>
        <p class="mx-2">{{nameFile}}</p>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <app-custom-button [label]="'Importar'" [severity]="'primary'" [variant]="undefined" [width]="'5rem'"
          (onClick)="importQuotations()"></app-custom-button>
      </div>
    </div>
    <div class="row">
      <div id="list" *ngIf="visibleTxt">
        <h6>Lista de Errores y Alertas</h6>
        <p>Total errores: {{breakdownAlerts.length}}</p>
        <div id="container-alerts" *ngFor="let breakdownAlert of breakdownAlerts">
          <p [ngClass]="errorBreakdown == 1 ? 'message-error' : 'message-alert'">
            {{breakdownAlert.message}}
          </p>
        </div>
      </div>
      <div class="row" *ngIf="visibleTxt">
        <div class="d-flex justify-content-end">
          <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'" [width]="'5.5rem'"
            (onClick)="downloadErrorsTxt()"></app-custom-button>
        </div>
      </div>
    </div>
  </div>
</section>